import React, { useState, useEffect } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  IconButton,
  Box,
  Text,
  Flex,
  Badge,
  Button,
  Spacer,
  useToast,
  useMediaQuery,
  Select,
} from "@chakra-ui/react";
import axios from "axios";
import { server } from "../util/connect";
import { useAuth } from "../auth/AuthProvider";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";
import "../css/CustomTable.css";
import DoctorProfileModal from "./modals/DoctorProfileModal";
import NoteEditorModal from "./modals/NoteEditorModal";
import { format } from "date-fns";
import { th } from "date-fns/locale/th";
import moment from "moment";
import Swal from "sweetalert2";
import TimeAgo from 'javascript-time-ago'

// English.
import tha from 'javascript-time-ago/locale/th'
TimeAgo.addDefaultLocale(tha)

function CalendarNote({}) {
  // Create formatter (English).
  const timeAgo = new TimeAgo('th-TH')

  const { user } = useAuth();
  const toast = useToast();

  const [notes, setNotes] = useState([]);
  const [selectedNote, setSelectedNote] = useState(null);
  const [isNoteModalOpen, setNoteModalOpen] = useState(false);
  const [isMobileScreen] = useMediaQuery("(max-width: 768px)");
  const [listType, setListType] = useState('current_list');

  const openNoteEditModal = (note) => {
    setSelectedNote(note);
    setNoteModalOpen(true);
  };

  const closeNoteEditModal = () => {
    setSelectedNote(null);
    setNoteModalOpen(false);
  };

  const dateDifference = (givenDate) => {
    // Calculate the difference between the current date and the given date
    const currentDate = moment();
    const difference = givenDate.diff(currentDate, 'days');
    return difference;
  }

  useEffect(() => {
    if (user && user.department_id) {
      fetchData();
    }
  }, [user]);

  const fetchData = async () => {
    const result = await axios.post(`${server}/note/fetch_all_notes`, {
      department_id: user.department_id,
    });
    setNotes(result.data.result);
  };

  const deleteNote = (note_id) => {
    // Use SweetAlert2 to show a confirmation dialog
    Swal.fire({
      title: "คุณแน่ใจหรือไม่?",
      text: "คุณต้องการลบรายการนี้หรือไม่?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ใช่, ลบ!",
      cancelButtonText: "ยกเลิก",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Use axios to send a DELETE request to your Node.js server
          const response = await axios.post(`${server}/note/delete_note`, {
            note_id,
          });

          if (response.data.status === "success") {
            toast({
              title: "ลบรายการเรียบร้อย",
              status: "success",
              duration: 3000,
              isClosable: true,
            });
            fetchData();
          } else {
            toast({
              title: "ไม่สามารถลบรายการได้",
              status: "error",
              duration: 3000,
              isClosable: true,
            });
          }
        } catch (error) {
          toast({
            title: "ไม่สามารถลบรายการได้",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      }
    });
  };

  const handleNoteSave = async (text, dueDate, notifyDate) => {
    try {
      // Use axios to send a POST request to your Node.js server
      const response = await axios.post(`${server}/note/save_note`, {
        note_id: selectedNote ? selectedNote.id : "",
        note: text,
        due_date: moment(dueDate).format("YYYY-MM-DD"),
        notify_date: moment(notifyDate).format("YYYY-MM-DD"),
        department_id: user.department_id,
      });

      if (response.data.status === "success") {
        toast({
          title: "บันทึกข้อมูลเรียบร้อย",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        fetchData();
      } else {
        toast({
          title: "ไม่สามารถบันทึกข้อมูลได้",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "ไม่สามารถบันทึกข้อมูลได้",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box>
      {isMobileScreen ? (
        <Box w="100%">
          <Flex justify={"space-between"} align={"center"} p={2}>
            <Flex direction={"column"}>
              <Text fontSize={14} fontWeight={600}>
                บันทึกช่วยจำ {user && user.department}
              </Text>
              <Select size={"xs"} defaultValue={'current_list'} onChange={(e)=>{
                //alert(e.target.value)
                setListType(e.target.value)
              }}>
                <option value='current_list'>รายการปัจจุบัน</option>
                <option value='prev_list'>รายการก่อนหน้า</option>
                <option value='all_list'>รายการทั้งหมด</option>
              </Select>
            </Flex>
            <Spacer />
            <Button
              size={"sm"}
              colorScheme="blue"
              onClick={() => openNoteEditModal(null)}
            >
              เพิ่มรายการ
            </Button>
          </Flex>
          {notes.map((note) => (
            (
              (dateDifference(moment(note.due_date)) < 0 && listType == "prev_list")
              || listType == "all_list"
              || (dateDifference(moment(note.due_date)) >= 0 && listType == "current_list")
            )
            
            && <Box
              mb={2}
              key={note.id}
              borderWidth="1px"
              borderRadius="lg"
              overflow="hidden"
              boxShadow="md"
            >
              <Flex bgColor="blue.100" p={2} alignItems="flex-start" justify={"space-between"}>
                <Flex>
                  <Text fontSize="xs" mr={1}>
                    กิจกรรมสำหรับวัน:{" "}
                  </Text>
                  <Text color="orange.700" fontSize="xs">
                    {format(note.due_date, "EEE dd MMM yyyy", {
                      locale: th,
                    })}
                  </Text>
                </Flex>
                <Spacer/>
                <Text color="gray" fontSize="xs">{timeAgo.format(moment(note.due_date).toDate())}</Text>
              </Flex>
              <Flex
                align="flex-start"
                p={4}
              >
                <Text mr={2} align="start" fontSize="lg" fontWeight="bold">
                  กิจกรรม:
                </Text>
                <Box pt={"2px"} dangerouslySetInnerHTML={{ __html: note.note }} />
              </Flex>

              <Flex borderWidth="1px" p={1} align={"center"} justify="space-between">
                <Flex align={"center"}>
                  <IconButton
                    size={"sm"}
                    bgColor="gray.200"
                    color="green.500"
                    aria-label="แก้ไขข้อมูลแพทย์"
                    icon={<EditIcon />}
                    mr={2}
                    onClick={() => openNoteEditModal(note)}
                  />
                  <Text color="grey" fontSize="xs">
                    ระบบจะแจ้งเตือนในวัน:{" "}
                    {format(note.notify_date, "EEE dd MMM yyyy", {
                      locale: th,
                    })}
                  </Text>
                </Flex>
                <Spacer />
                <Flex>
                  <IconButton
                    size={"sm"}
                    bgColor="gray.200"
                    color="red.500"
                    aria-label="ลบแพทย์"
                    icon={<DeleteIcon />}
                    onClick={() => deleteNote(note.id)}
                  />
                </Flex>
              </Flex>
            </Box>
          ))}
          {!notes || (notes.length === 0 && <Text>ไม่มีรายการ</Text>)}
        </Box>
      ) : (
        <Box p={2} display="flex" alignItems="center" justifyContent="center">
          <Box
            w={"1300px"}
            overflowX="auto"
            css={{
              "&::-webkit-scrollbar": {
                height: "6px",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#a0aec0",
              },
            }}
          >
            <Box
              position="relative"
              alignItems="center"
              justifyContent="center"
            >
              <Flex justify={"space-between"} align={"center"} mb={2}>
                <Text fontSize={16} fontWeight={600}>
                  กิจกรรม/บันทึกช่วยจำ {user && user.department}
                </Text>
                <Spacer />
                <Button
                  size={"sm"}
                  colorScheme="blue"
                  onClick={() => openNoteEditModal(null)}
                >
                  เพิ่มรายการ
                </Button>
              </Flex>
              <Table className="custom-table">
                <Thead>
                  <Tr>
                    <Th>วันที่แจ้งเตือน</Th>
                    <Th>วันครบกำหนด</Th>
                    <Th>กิจกรรม</Th>
                    <Th>Actions</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {notes &&
                    notes.length > 0 &&
                    notes.map((note) => (
                      <Tr key={note.id}>
                        <Td minW={"110px"}>
                          {format(note.notify_date, "EEEE dd MMMM yyyy", {
                            locale: th,
                          })}
                        </Td>
                        <Td minW={"110px"}>
                          {format(note.due_date, "EEEE dd MMMM yyyy", {
                            locale: th,
                          })}
                        </Td>
                        <Td minW={"250px"}>
                          {
                            <Box
                              dangerouslySetInnerHTML={{ __html: note.note }}
                            />
                          }
                        </Td>
                        <Td minW={"150px"} w={"150px"}>
                          <IconButton
                            bgColor="gray.200"
                            color="green.500"
                            ml={2}
                            aria-label={"แก้ไขข้อมูลแพทย์"}
                            icon={<EditIcon />}
                            size="md"
                            onClick={() => openNoteEditModal(note)}
                          />

                          <IconButton
                            bgColor="gray.200"
                            color="red.500"
                            ml={2}
                            aria-label={"ลบแพทย์"}
                            icon={<DeleteIcon />}
                            onClick={() => deleteNote(note.id)}
                            size="md"
                          />
                        </Td>
                      </Tr>
                    ))}

                  {(!notes || notes.length <= 0) && (
                    <Tr>
                      <Td colSpan={4}>ไม่มีรายการ</Td>
                    </Tr>
                  )}
                </Tbody>
              </Table>
            </Box>
          </Box>
        </Box>
      )}

      <NoteEditorModal
        isOpen={isNoteModalOpen}
        onClose={closeNoteEditModal}
        onSave={handleNoteSave}
        initialNote={selectedNote}
      />
    </Box>
  );
}

export default CalendarNote;
